import React, { useState, useEffect, useCallback, memo } from 'react';
import {
  Container,
  Typography,
  Box,
  Slider,
  Button,
  Tabs,
  Tab,
  Snackbar,
  Alert,
  Paper
} from '@mui/material';
import BPSUserManagement from '../../components/Configuration/BPSUserManagement/BPSUserManagement';
import BPSScheduleConfig from '../../components/BPSScheduleConfig';
import ExcelUpload from '../../components/Configuration/ExcelUpload/ExcelUpload';
import { getSpeed, setSpeed } from '../../services/configurationService';
import './Configuration.css';

const TabPanel = memo(function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`config-tabpanel-${index}`}
      aria-labelledby={`config-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
});

const Configuration = () => {
  const [speed, setSpeedValue] = useState(25);
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const fetchSpeed = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getSpeed();
      setSpeedValue(response);
    } catch (error) {
      console.error('Error fetching speed:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSpeed();
  }, [fetchSpeed]);

  const handleSpeedChange = useCallback((event, newValue) => {
    setSpeedValue(newValue);
  }, []);

  const handleCancel = useCallback(() => {
    fetchSpeed();
  }, [fetchSpeed]);

  const handleSave = useCallback(async () => {
    try {
      await setSpeed(speed);
      setShowSuccess(true);
    } catch (error) {
      console.error('Error saving speed:', error);
    }
  }, [speed]);

  const handleTabChange = useCallback((event, newValue) => {
    setTabIndex(newValue);
  }, []);

  const handleCloseSnackbar = useCallback(() => {
    setShowSuccess(false);
  }, []);

  return (
    <Container className="configuracion-container">
      <Box my={2}>
        <Typography 
          variant="h4" 
          gutterBottom 
          className="configuracion-title"
        >
          Configuración Lead+
        </Typography>
        
        <Paper>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabIndex} onChange={handleTabChange}>
              <Tab label="Velocidad" />
              <Tab label="Usuarios BPS" />
              <Tab label="Horario BPS" />
              {/* <Tab label="Carga de Excel" /> */}
            </Tabs>
          </Box>

          <TabPanel value={tabIndex} index={0}>
            <Box mt={4}>
              <Typography variant="body1">
                Aquí puedes ajustar la velocidad de ejecución para ejecutar la automatización de BPS.
              </Typography>

              <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                  Velocidad de Ejecución
                </Typography>

                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Registros a procesar por hora por usuario: {speed}
                </Typography>

                {!loading && (
                  <Slider
                    value={speed}
                    onChange={handleSpeedChange}
                    aria-labelledby="speed-slider"
                    valueLabelDisplay="auto"
                    step={10}
                    marks
                    min={10}
                    max={100}
                  />
                )}
              </Box>

              <Box mt={4} display="flex" justifyContent="space-between">
                <Button 
                  variant="contained" 
                  color="secondary" 
                  onClick={handleCancel}
                >
                  Cancelar
                </Button>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleSave}
                >
                  Guardar
                </Button>
              </Box>
            </Box>
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <Box mt={2}>
              <BPSUserManagement />
            </Box>
          </TabPanel>

          <TabPanel value={tabIndex} index={2}>
            <Box mt={2}>
              <BPSScheduleConfig />
            </Box>
          </TabPanel>

          {/* <TabPanel value={tabIndex} index={3}>
            <ExcelUpload />
          </TabPanel> */}
        </Paper>

        <Snackbar 
          open={showSuccess} 
          autoHideDuration={3000} 
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
            Configuración guardada exitosamente
          </Alert>
        </Snackbar>
      </Box>
    </Container>
  );
};

export default memo(Configuration);